import { useRef, useState } from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';

/**
 * Значок «i» с пояснением вместо постоянной подписи под заголовком.
 *
 * Состояние открытия своё, а не из Radix: его Tooltip на касание не открывается вовсе, и на
 * телефоне пояснение было бы недоступно. Radix закрывает подсказку на pointerdown ещё до click,
 * поэтому решение о переключении опирается на состояние, снятое до этого закрытия: иначе второе
 * нажатие открывало бы подсказку снова. `preventDefault` в click отключает его собственное
 * закрытие. Клавиатурный click (`detail === 0`) идёт без pointerdown, снимка у него нет.
 */
const InfoHint = ({ text, label = 'Пояснение', trackId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wasOpenBeforePress = useRef(false);

  if (!text) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={isOpen} onOpenChange={setIsOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-ev={trackId}
            aria-label={label}
            onPointerDown={() => {
              wasOpenBeforePress.current = isOpen;
            }}
            onClick={(event) => {
              event.preventDefault();
              setIsOpen(!(event.detail === 0 ? isOpen : wasOpenBeforePress.current));
            }}
            className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <Info className="h-4 w-4" strokeWidth={1.8} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          sideOffset={9}
          className="max-w-[min(22rem,calc(100vw-2rem))] rounded-lg border bg-popover px-3 py-2 text-sm leading-relaxed text-popover-foreground shadow-md"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoHint;
